import Likes from './container';

export default Likes;



// WEBPACK FOOTER //
// ./src/components/Steps/Likes/index.js